module.exports = __webpack_public_path__ + "static/media/start.b6e296e0.png";